module.exports = __webpack_public_path__ + "img/Share 3.96fb070b.png";